export function getCurrentLocale()
{
    return document.getElementsByTagName('html')[0].getAttribute('lang').replace('-', '_');
}

export function getCurrentLanguage()
{
    return getCurrentLocale().split('_')[0];
}